<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/home/selfAccount' }"
          >自有账户</el-breadcrumb-item
        >
        <el-breadcrumb-item>编辑</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="never">
      <div slot="header" class="box-card">
        <span>编辑</span>
      </div>
      <div class="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form
              ref="form"
              :model="form"
              label-width="200px"
              :rules="rules"
            >
              <el-form-item label="商户ID" prop="applicationUserId">
                <el-select
                  v-model="form.applicationUserId"
                  filterable
                  @change="setUpload"
                >
                  <el-option
                    v-for="item in view.merchantIdList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提现助手充值类型" prop="settlementType">
                <el-select v-model="form.settlementType">
                  <el-option label="T0" :value="0"></el-option>
                  <el-option label="T1" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="IP白名单">
                <el-input v-model="form.whiteIp" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="应用ID">
                <el-input v-model="form.appId"></el-input>
              </el-form-item>
              <el-form-item label="支付宝私匙" prop="aliPayPrivateKey">
                <el-input
                  v-model="form.aliPayPrivateKey"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="应用公钥证书路径"
                prop="aliPayAppPubCertPath"
              >
                <el-input v-model="form.aliPayAppPubCertPath"></el-input>
                <el-upload
                  :action="action"
                  :headers="headers"
                  :on-success="upload1"
                  :data="uploadConfig"
                  :limit="1"
                  :show-file-list="false"
                >
                  <el-button type="primary" icon="el-icon-plus" class="mgt10"
                    >上传应用公钥证书</el-button
                  >
                </el-upload>
              </el-form-item>
              <el-form-item
                label="支付宝公钥证书文件路径"
                prop="aliPayPubCertPath"
              >
                <el-input v-model="form.aliPayPubCertPath"></el-input>

                <el-upload
                  :action="action"
                  :headers="headers"
                  :on-success="upload2"
                  :data="uploadConfig"
                  :limit="1"
                  :show-file-list="false"
                >
                  <el-button type="primary" icon="el-icon-plus" class="mgt10"
                    >支付宝公钥证书文件</el-button
                  >
                </el-upload>
              </el-form-item>
              <el-form-item
                label="支付宝CA根证书文件路径"
                prop="aliPayCaCertPath"
              >
                <el-input v-model="form.aliPayCaCertPath"></el-input>
                <el-upload
                  :action="action"
                  :headers="headers"
                  :on-success="upload3"
                  :data="uploadConfig"
                  :limit="1"
                  :show-file-list="false"
                >
                  <el-button type="primary" icon="el-icon-plus" class="mgt10"
                    >支付宝CA根证书文件</el-button
                  >
                </el-upload>
              </el-form-item>
              <el-form-item label="状态" prop="state">
                <el-select v-model="form.state">
                  <el-option label="禁用" :value="0"></el-option>
                  <el-option label="正常" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('form')"
                  >保存</el-button
                >
                <el-button @click="resetForm('form')">取消</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
import { url } from '../../assets/js/version';
export default {
  data() {
    return {
      action: url + '/api/Paid/UploadCert',
      headers: {
        UserId: 0
      },
      uploadConfig: {},
      form: {
        id: 0,
        applicationUserId: '',
        settlementType: 0,
        appId: '',
        aliPayPrivateKey: '',
        aliPayAppPubCertPath: '',
        aliPayPubCertPath: '',
        aliPayCaCertPath: '',
        state: 0,
        whiteIp: ''
      },
      rules: {
        applicationUserId: [
          {
            required: true,
            message: '请输入商户ID',
            trigger: 'blur'
          }
        ],
        settlementType: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }
        ],
        state: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'blur'
          }
        ],
        aliPayPrivateKey: [
          {
            required: true,
            message: '请上传证书',
            trigger: 'blur'
          }
        ],
        aliPayAppPubCertPath: [
          {
            required: true,
            message: '请上传证书',
            trigger: 'blur'
          }
        ],
        aliPayPubCertPath: [
          {
            required: true,
            message: '请上传证书',
            trigger: 'blur'
          }
        ],
        aliPayCaCertPath: [
          {
            required: true,
            message: '请上传证书',
            trigger: 'blur'
          }
        ]
      },
      view: {}
    };
  },
  mounted() {
    this.form.id = this.$route.query.id;
    this.form.applicationUserId = this.$route.query.userId;
    this.getView();
    this.getDetail();
  },
  methods: {
    async setUpload() {
      let header = await mgr();
      this.headers = {
        Authorization: 'Bearer ' + header,
        UserId: this.form.applicationUserId
      };
    },
    async getView() {
      let header = await mgr();
      api
        .get('/api/Paid/GetPaidVersionInfo', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.view = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async getDetail() {
      let header = await mgr();
      api
        .get('/api/Paid/GetPaidAccount', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {
            userId: this.form.applicationUserId
          }
        })
        .then(res => {
          this.form = res.data;
          // this.form.whiteIp = res.data.whiteIp.join('\n');
          this.setUpload();
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async save() {
      let header = await mgr();
      this.form.applicationUserId = Number(this.form.applicationUserId);
      if (this.form.whiteIp === '') {
        this.$message.error('ip不能为空');
        return;
      }
      this.form.whiteIp = this.form.whiteIp.split(',');
      api
        .post('/api/Paid/EditPaidAccount', this.form, {
          headers: {
            Authorization: 'Bearer ' + header
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    upload1(response, file, fileList) {
      this.form.aliPayAppPubCertPath = response;
    },
    upload2(response, file, fileList) {
      this.form.aliPayPubCertPath = response;
    },
    upload3(response, file, fileList) {
      this.form.aliPayCaCertPath = response;
    }
  }
};
</script>
<style></style>
<style scoped></style>
